import React, { useEffect, useState } from 'react';

import SnowfallBackground from './SnowfallBackground';

export default () => {
  const [snowfallSeason, setSnowfallSeason] = useState<boolean>(false);
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    // SnowSeason od 6 grudnia do 28 lutego
    const startOfSnowSeason = new Date(currentYear, 11, 6);
    const endOfSnowSeason = new Date(currentYear, 1, 28);

    if (today >= startOfSnowSeason || today <= endOfSnowSeason) {
      setSnowfallSeason(true);
      return;
    }
    setSnowfallSeason(false);
  }, []);
  return <>{snowfallSeason && <SnowfallBackground />}</>;
};
